"use strict";
exports.__esModule = true;
exports.HeatmapLegend = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var ColorLegend_1 = require("./ColorLegend");
/**
 * @internal
 */
var HeatmapLegend = /** @class */ (function (_super) {
    tslib_1.__extends(HeatmapLegend, _super);
    function HeatmapLegend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeatmapLegend.prototype.render = function () {
        var _a = this.props, title = _a.title, series = _a.series, format = _a.format, numericSymbols = _a.numericSymbols, size = _a.size, position = _a.position;
        var data = series.map(function (item) {
            var range = item.range, color = item.color;
            return { range: range, color: color };
        });
        return (react_1["default"].createElement(ColorLegend_1.ColorLegend, { data: data, format: format, size: size, numericSymbols: numericSymbols, position: position, title: title }));
    };
    return HeatmapLegend;
}(react_1["default"].PureComponent));
exports.HeatmapLegend = HeatmapLegend;
//# sourceMappingURL=HeatmapLegend.js.map